import md5 from 'blueimp-md5';
import sortBy from 'lodash/sortBy';

/**
 *
 * generates a hash for a specific anchor (test type) and an array of tags.
 *
 * @param {String} anchor
 * @param {Array} tags
 */

const queryHashGenerator = (anchor: string, tags: string[]): string => {
  if (tags && tags.length) {
    return md5(anchor + sortBy(tags).join(''));
  } else {
    return md5(anchor);
  }
};

export { queryHashGenerator, queryHashGenerator as queryHash };
